<template>
    <!-- 工作室简介 -->
    <div class="introduction">
        <div class="introduce-item">
            <h3 class="title">主持人简介</h3>
            <div class="text">
                <p>王海燕——现任国家教育咨询委员会委员、第一组组长、教育部社会科学委员会副主任、教育部新时代中国特色社会主义思想研究中心顾问、国家教育发展研究中心专家咨询委员会副主任委员、国家教师教育咨询专家委员会主任委员、教育部教师教育专家委员会主任委员、普通高等学校师范类专业认证专家委员会副主任、全国师德师风建设专家委员会总顾问
                    、中国教育学会名誉会长 等职务。曾任世界比较教育学会联合会主席，国务院学位委员会教育学科评议组召集人
                    ，国家教委中小学教材审定委员会副主任，全国教育硕士专业学位教育指导委员会主任，北京师范大学副校长；兼任北京大学、清华大学等院校兼职教授。担任《比较教育研究》、《中国教育学刊》等杂志主编，《教育研究》等多家学术期刊学术委员会顾问
                    [3] 。多次担任国家及教育部重大项目的负责人，主编《教育大辞典》、《中国教育大百科全书》等多部大型教育辞书，出版专著40余部，发表论文千余篇 。</p>
            </div>
        </div>
        <div class="introduce-item">
            <h3 class="title">工作室简介</h3>
            <div class="text">
                <p>国家教育咨询委员会委员、第一组组长<br>
                    教育部社会科学委员会副主任委员<br>
                    教育部新时代中国特色社会主义思想研究中心顾问<br>
                    国家教育发展研究中心专家咨询委员会副主任委员<br>
                    国家教师教育咨询专家委员会主任委员<br>
                    教育部教师教育专家委员会主任委员<br>
                    普通高等学校师范类专业认证专家委员会副主任<br>
                    全国师德师风建设专家委员会总顾问<br>
                    中国教育学会名誉会长<br>
                    中国高等教育学会高等师范教育研究会顾问<br>
                    中国高等教育学会高等教育评估研究会名誉理事长<br>
                </p>
            </div>
        </div>
        <div class="introduce-item">
            <h3 class="title">工作室成果简介</h3>
            <div class="text">
                <p>2007年 《中国教育的文化基础》获教育部第四届高等学校哲学社会科学优秀成果一等奖<br>
                    2010年 《改革开放30年中国教育纪实》（主编之一）获北京市第十一届哲学社会科学优秀成果一等奖<br>
                    2013年 《国家中长期教育改革和发展规划纲要>解读》（主编之一）获北京市第六届教育科学研究优秀成果奖一等奖<br>
                    2014年 《中国教育大百科全书》（主编）获北京市第十三届哲学社会科学优秀成果特等奖<br>
                    2015年 获教育部高等学校哲学社会科学优秀成果一等奖<br>
                    2014年 获吴玉章人文社会科学终身成就奖<br>
                    2015年 《中国教育大百科全书》（主编）获教育部第七届高校科学研究优秀成果奖一等奖<br>
                    2016年 《比较教育（第五版）》（主编之一）获第五届全国教育科学研究成果二等奖<br>
                    2017年 《从新民主主义教育到社会主义教育（1921-2012）》（主编之一）获第十四届北京市哲学社会科学优秀成果奖二等奖<br>
                    2018年 “中小幼名优教师学习与发展双向互助合作模式”与郭华、周作宇共获北京教学成果特等奖、高等教育国家级教学成果奖一等奖<br>
                    2018年 获北京师范大学“四有好老师”终身成就奖<br>
                    2019年 《中国学校研究》与马建生、滕珺共获北京市第十五届哲学社会科学优秀成果奖一等奖<br>
                    2020年《顾明远文集》获北京市第十六届哲学社会科学优秀成果奖特等奖。<br>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="less" scoped>
    .introduce-item {
        &:nth-child(2) .title {
            background-image: url("../../assets/studio/title-2.png");
        }

        &:nth-child(3) .title {
            background-image: url("../../assets/studio/title-3.png");
        }
    }

    .title {
        background-image: url("../../assets/studio/title-1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 24px;
        line-height: 3.4;
        color: #fff;
        font-weight: bold;
        padding-left: 12.3%;
    }

    .text {
        padding: 2% 0 4% 4%;
        font-size: 18px;
        line-height: 2.2;
        font-weight: 300;
    }
</style>